import { ref, onMounted, onUnmounted } from 'vue';
export default function useDetailDrawer(cb) {
  const drawerVisible = ref(false);
  const setDrawerVisible = (flag) => {
    drawerVisible.value = flag ?? !drawerVisible.value;
  };
  // 关闭弹窗
  const closeDialog = () => {
    drawerVisible.value = false;
  };
  // 点击其他区域关闭
  const drawerClose = (e) => {
    const app = document.querySelector('#app');
    if (app) {
      const isSelf = app?.contains?.(e.target);
      if (isSelf && drawerVisible) {
        drawerVisible.value = false;
        cb?.();
      }
    }
  };
  onMounted(() => {
    // 点击其他颜色以外，关闭其他颜色弹窗
    document.addEventListener('click', drawerClose);
  });
  onUnmounted(() => {
    document.removeEventListener('click', drawerClose);
  });
  return { drawerVisible, setDrawerVisible, closeDialog };
}
